import { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/forms'
import { CategoryHeader } from 'registry/components/reg-item-category/reg-item-category'

export default class EditableCategoryHeader extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      title: props.title,
    }
  }

  handleCategoryTitleChange = ({ target: { value } }) => {
    this.setState({ title: value })
  }

  handleCategoryTitleKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.handleCategoryTitleUpdate(this.state.title)
    }
  }

  render() {
    const { title } = this.state
    const { handleCategoryTitleUpdate } = this.props

    return (
      <CategoryHeader className="mvl" isContributorView={true}>
        <Input
          type="text"
          size="md"
          value={title}
          autoFocus
          aria-label="Edit Category Title"
          onChange={this.handleCategoryTitleChange}
          onBlur={() => handleCategoryTitleUpdate(title)}
          onKeyDown={this.handleCategoryTitleKeyDown}
        />
      </CategoryHeader>
    )
  }
}

export { CategoryHeader }
